export const ROOT = "/";
export const LOGIN = "/login";
export const PAYMENT = "/payment";
export const PAYMENT_VERIFICATION = "/payment/post-verification";
export const VENUE_MENU = "/v/:id/menu";
export const VENUE = "/v/:id";
export const GROUP_VENUE_MENU = "/g/:group/:id/menu";
export const GROUP = "/g/:group";
export const GROUP_VENUE = "/g/:group/:id";
export const NOT_FOUND = "/not-found";
